import { InputError } from "@app/components/core/InputError/InputError"
import { classNamez } from "@tecreation/funnel-components"
import "./Input.css"

const Input = ({
	type,
	label,
	name,
	className,
	placeholder,
	required,
	autocomplete,
	formRegister,
	inputRef,
	disabled,
	onChange,
	errors,
	onKeyDown,
	hideLabel,
	onFocusChange,
	...htmlProps
}) => {
	const errorMessage = formRegister && errors && errors[formRegister.name] ? errors[formRegister.name].message : undefined
	const inputId = formRegister?.name ?? name

	return (
		<div className="flex-1">
			<div className={"input outlined primary " + className + classNamez({ "has-error": !!errorMessage })}>
				<input
					onChange={onChange || (() => {})}
					name={name}
					id={inputId}
					type={type}
					required={required}
					placeholder={placeholder}
					autoComplete={autocomplete}
					ref={inputRef}
					disabled={disabled}
					aria-required={required}
					onKeyDown={onKeyDown}
					aria-invalid={!!errorMessage}
					aria-describedby={errorMessage ? `${inputId}-error` : undefined}
					{...formRegister}
					{...htmlProps}
					onFocus={e => onFocusChange?.(true, e)}
					onBlur={e => onFocusChange?.(false, e)}
				/>
				<label htmlFor={inputId} className={hideLabel && "sr-only"}>
					{label ?? inputId}
				</label>
			</div>

			{formRegister && <InputError message={errorMessage} id={`${inputId}-error`} />}
		</div>
	)
}

export default Input
